// Text carousel — no drag, no arrows, driven by fc-image-carousel
if (!customElements.get('fc-text-carousel')) {
  class FcTextCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        updateOnMove: true,
        drag: false,
        perPage: 1,
        gap: 0,
        arrows: false,
        pagination: false,
      };
    }

    connectedCallback() {
      this.slider = new Splide(this, this.options).mount();
    }
  }
  customElements.define('fc-text-carousel', FcTextCarousel);
}

// Image carousel — peek on sides, arrows, drives fc-text-carousel
if (!customElements.get('fc-image-carousel')) {
  class FcImageCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      const isMobile = window.matchMedia('(max-width: 767px)').matches;

      this.options = {
        type: isMobile ? 'loop' : 'slide',
        updateOnMove: true,
        drag: false,
        perPage: 1,
        gap: 20,
        height: 400,
        arrows: true,
        pagination: false,
        breakpoints: {
          767: {
            gap: 20,
            padding: { left: 100, right: 100 },
            drag: true,
            height: 400,
          },
          480: {
            gap: 20,
            padding: { left: 90, right: 90 },
            drag: true,
            height: 255,
          }
        }
      };
    }

    connectedCallback() {
      this.slider = new Splide(this, this.options).mount();

      const textCarousel = this.closest('.section-fc__mobile').querySelector('fc-text-carousel');
      if (!textCarousel) return;

      this.slider.on('moved', (newIndex) => {
        textCarousel.slider.go(newIndex);
      });
    }
  }
  customElements.define('fc-image-carousel', FcImageCarousel);
}
